var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2027 7.05273L10.0536 3.90365M1 16.1063L3.66441 15.8103C3.98994 15.7741 4.1527 15.756 4.30484 15.7068C4.43981 15.6631 4.56826 15.6014 4.68669 15.5233C4.82019 15.4352 4.93599 15.3194 5.16759 15.0878L15.5645 4.69092C16.4341 3.82133 16.4341 2.41144 15.5645 1.54184C14.6949 0.672251 13.285 0.67225 12.4154 1.54184L2.01851 11.9387C1.78691 12.1703 1.67111 12.2861 1.58308 12.4196C1.50498 12.5381 1.44324 12.6665 1.39955 12.8015C1.3503 12.9536 1.33222 13.1164 1.29605 13.4419L1 16.1063Z",
    stroke: "#38cb89",
    strokeWidth: 1.57454,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreen);
export default __webpack_public_path__ + "static/media/edit-green.eca29bc0155fadf0d509914be5210174.svg";
export { ForwardRef as ReactComponent };